import gql from 'graphql-tag';

export default gql`
  query listUserSegments {
    listUserSegments {
      items {
        userSegmentId
        name
        fileName
        filePath
        uId
      }
    }
  }
`;
